import React, {Fragment, useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";

import {nanoid} from 'nanoid'
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles';


function LineUp({data}) {

    const theme = useTheme();
    const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);
    
    const lineUpCard = {
        paddingTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            textTransform: 'capitalize',    
            color: theme.palette.primary.contrastText,         
            fontWeight: 400,
            marginBottom: theme.spacing(1)
        },    
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            color: theme.palette.primary.contrastText,
            textTransform: 'capitalize !important',
            border: `1px solid ${theme.palette.background.borderColor}`,
            backgroundColor: theme.palette.background.alternate,
            display: 'inline-block',        
            padding: '8px 16px',
            borderRadius: 1.5,
            marginRight: 1,
            textAlign: 'center',
            fontWeight: 400,
            marginBottom: 1,
            [theme.breakpoints.down("md")]: {
                padding: '6px 12px',
            }
                    
        },
        [theme.breakpoints.down("md")]: {
            marginTop: theme.spacing(2),
            paddingTop: theme.spacing(2),
            // borderTop: `1px solid ${theme.palette.background.borderColor}`,
            borderColor: theme.palette.grey[900],
        }
    };
     
  return (
      <>
          {data.event_artists.length > 0 ? (
              <Typography component="div" sx={lineUpCard}>
                  <Typography variant="h5">Line Up</Typography>
                  {data.event_artists.split(",").map((step, i) => (
                      <Typography variant="h6" key={nanoid(30)}>
                          {step.toLowerCase()}
                          {"\n"}
                      </Typography>
                  ))}
              </Typography>
          ) : ('')}  
    </>
  );
}

export default LineUp;




                            